module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/area-1-c43d112e05b10ec92806c43536a9740b.jpg";